"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Consumer = void 0;
exports.Provider = Provider;
exports.consumer = consumer;
exports["default"] = void 0;
exports.withI18n = withI18n;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _interpolate = _interopRequireDefault(require("interpolate"));
var _excluded = ["locales", "children"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function identity(v) {
  return v;
}
var LocaleContext = /*#__PURE__*/React.createContext({
  locale: 'en_US',
  locales: {},
  i18n: identity
});
var getLocale = function getLocale(locales) {
  return function (id, params) {
    return locales && id && (0, _interpolate["default"])(locales[id] || '', params) || id;
  };
};
function Provider(_ref) {
  var locales = _ref.locales,
    children = _ref.children,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/React.createElement(LocaleContext.Provider, {
    value: _objectSpread({
      locales: locales,
      i18n: getLocale(locales),
      locale: 'en_US'
    }, rest)
  }, children);
}
function consumer(Comp) {
  var I18nConsumer = function I18nConsumer(_ref2) {
    var id = _ref2.id,
      params = _ref2.params;
    return /*#__PURE__*/React.createElement(LocaleContext.Consumer, null, function (_ref3) {
      var i18n = _ref3.i18n;
      return id ? /*#__PURE__*/React.createElement(Comp, {
        value: i18n(id, params)
      }) : null;
    });
  };
  return I18nConsumer;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function withI18n(Comp) {
  var I18nHOC = function I18nHOC(props, ref) {
    return /*#__PURE__*/React.createElement(LocaleContext.Consumer, null, function (_ref4) {
      var i18n = _ref4.i18n;
      return /*#__PURE__*/React.createElement(Comp, (0, _extends2["default"])({
        i18n: i18n
      }, props, {
        ref: ref
      }));
    });
  };
  return /*#__PURE__*/React.forwardRef(I18nHOC);
}
var Consumer = exports.Consumer = LocaleContext.Consumer;
var _default = exports["default"] = LocaleContext;